const TYPE_COLORS = ['#facc15', '#60a5fa', '#f87171', '#c084fc', '#34d399'];

function getPathValue(pathLayer: readonly number[] | undefined, width: number, height: number, x: number, y: number): number {
  if (!pathLayer || x < 0 || y < 0 || x >= width || y >= height) {
    return 0;
  }
  const value = pathLayer[(y * width) + x];
  return typeof value === 'number' && Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;
}

function buildMask(pathLayer: readonly number[] | undefined, width: number, height: number, x: number, y: number, pathType: number): number {
  let mask = 0;
  if (getPathValue(pathLayer, width, height, x, y) === pathType) mask |= 1;
  if (getPathValue(pathLayer, width, height, x + 1, y) === pathType) mask |= 2;
  if (getPathValue(pathLayer, width, height, x, y + 1) === pathType) mask |= 4;
  if (getPathValue(pathLayer, width, height, x + 1, y + 1) === pathType) mask |= 8;
  return mask;
}

function collectIntersectionPathTypes(
  pathLayer: readonly number[] | undefined,
  width: number,
  height: number,
  x: number,
  y: number,
): number[] {
  const values = new Set<number>();
  for (const [dx, dy] of [[0, 0], [1, 0], [0, 1], [1, 1]] as const) {
    const value = getPathValue(pathLayer, width, height, x + dx, y + dy);
    if (value > 0) {
      values.add(value);
    }
  }
  return Array.from(values.values()).sort((left, right) => left - right);
}

function fallbackPathColor(pathType: number): string {
  return TYPE_COLORS[(Math.max(1, pathType) - 1) % TYPE_COLORS.length];
}

function drawProceduralMask(
  context: CanvasRenderingContext2D,
  dx: number,
  dy: number,
  drawSize: number,
  mask: number,
  pathType: number,
): void {
  const half = drawSize / 2;
  const centerX = dx + half;
  const centerY = dy + half;
  const color = fallbackPathColor(pathType);

  context.save();
  context.globalAlpha = 0.82;
  context.strokeStyle = color;
  context.fillStyle = color;
  context.lineCap = 'round';
  context.lineJoin = 'round';
  context.lineWidth = drawSize * 0.24;
  context.beginPath();
  if ((mask & 1) !== 0) {
    context.moveTo(centerX, centerY);
    context.lineTo(dx, dy);
  }
  if ((mask & 2) !== 0) {
    context.moveTo(centerX, centerY);
    context.lineTo(dx + drawSize, dy);
  }
  if ((mask & 4) !== 0) {
    context.moveTo(centerX, centerY);
    context.lineTo(dx, dy + drawSize);
  }
  if ((mask & 8) !== 0) {
    context.moveTo(centerX, centerY);
    context.lineTo(dx + drawSize, dy + drawSize);
  }
  context.stroke();

  context.beginPath();
  context.arc(centerX, centerY, drawSize * 0.12, 0, Math.PI * 2);
  context.fill();
  context.restore();
}

export function prepareSquarePathAtlas(_onUpdate: () => void): void {}

export function drawSquarePathOverlay(
  context: CanvasRenderingContext2D,
  params: {
    pathLayer?: readonly number[];
    mapWidth: number;
    mapHeight: number;
    tileX: number;
    tileY: number;
    drawX: number;
    drawY: number;
    drawSize: number;
  }
): void {
  const pathTypes = collectIntersectionPathTypes(
    params.pathLayer,
    params.mapWidth,
    params.mapHeight,
    params.tileX,
    params.tileY,
  );
  if (pathTypes.length === 0) {
    return;
  }

  for (const pathType of pathTypes) {
    const mask = buildMask(
      params.pathLayer,
      params.mapWidth,
      params.mapHeight,
      params.tileX,
      params.tileY,
      pathType,
    );
    if (mask === 0) {
      continue;
    }
    drawProceduralMask(context, params.drawX, params.drawY, params.drawSize, mask, pathType);
  }
}
